/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const TreeViewIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Tree View',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <rect x="2" y="2" width="6" height="6" rx=".5" ry=".5" />
    <rect x="10" y="4" width="24" height="4" rx=".25" ry=".25" />
    <rect x="18" y="16" width="16" height="4" rx=".25" ry=".25" />
    <rect x="18" y="28" width="16" height="4" rx=".25" ry=".25" />
    <rect x="10" y="14" width="6" height="6" rx=".5" ry=".5" />
    <rect x="10" y="26" width="6" height="6" rx=".5" ry=".5" />
  </svg>`;
};
